import { CiHeart } from "react-icons/ci";
import { IoShareSocialOutline } from "react-icons/io5";
import { LuPrinter } from "react-icons/lu";
import { CiLocationOn } from "react-icons/ci";
import { FaChevronLeft, FaChevronRight, FaDollarSign } from "react-icons/fa6";
import { FiPhoneCall } from "react-icons/fi";
import { IoMailOutline } from "react-icons/io5";
import { FiClock } from "react-icons/fi";
import { CiFacebook } from "react-icons/ci";
import { FaXTwitter } from "react-icons/fa6";
import { IoLogoInstagram } from "react-icons/io5";
import { FiYoutube } from "react-icons/fi";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import { PiClockCountdown } from "react-icons/pi";
import { PiLifebuoyLight } from "react-icons/pi";
import { PiSketchLogoLight } from "react-icons/pi";
import { FaStar } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { RiCloseLargeLine } from "react-icons/ri";

export const icons = {
  croseIcon: <RiCloseLargeLine />,
  hamburgerIcon: <GiHamburgerMenu />,
  starIcon: <FaStar />,
  phoneIcon: <FiPhoneCall />,
  clockIcon2: <PiClockCountdown />,
  lifeBuoyIcon: <PiLifebuoyLight />,
  dimondIcon: <PiSketchLogoLight />,
  leftAngleIcon: <FaChevronLeft />,
  rightAngleIcon: <FaChevronRight />,
  angleUpIcon: <FaAngleUp />,
  angleDownIcon: <FaAngleDown />,
  mailIcon: <IoMailOutline />,
  clockIcon: <FiClock />,
  facebookIcon: <CiFacebook />,
  twitterIcon: <FaXTwitter />,
  instagramIcon: <IoLogoInstagram />,
  youtubeIcon: <FiYoutube />,
  heartIcon: <CiHeart />,
  shareicon: <IoShareSocialOutline />,
  printIcon: <LuPrinter />,
  locationIcon: <CiLocationOn />,
  dollarIcon: <FaDollarSign />,
};
